import React from 'react';
import { observer } from 'mobx-react';
import { IGetApiType } from '../../../REST';
import { useTariffPackageInstanceItem } from '../../../hooks';
import { CardLayout, Catcher, cardLayoutOptions } from '../../../Components';
import { PackageUsageStatisticsCard } from '../../Card/Components';

export const ShowTariffPackageInstanceUsages: React.FC = observer(() => {
    const loadingTypes: IGetApiType[] = ['GET_TARIFF_PACKAGE_INSTANCE'];
    const info = useTariffPackageInstanceItem();

    return (
        <Catcher>
            <CardLayout
                columnOption={cardLayoutOptions.cardEditCompanyCustomize}
                idSpinners={loadingTypes}
                title={'Usages'}
            >
                <PackageUsageStatisticsCard
                    dataTotal={info.dataVolumeTotal}
                    dataUsage={info.dataVolumeTotal - info.dataVolumeAvailable}
                    smsTotal={info.smsVolumeTotal}
                    smsUsage={info.smsVolumeTotal - info.smsVolumeAvailable}
                    voiceTotal={info.voiceVolumeTotal}
                    voiceUsage={info.voiceVolumeTotal - info.voiceVolumeAvailable}
                />
            </CardLayout>
        </Catcher>
    );
});
